// extracted by mini-css-extract-plugin
export var orderDetails = "_ue-2";
export var orderImage = "_ue-1";
export var orderMeta = "_ue-3";
export var orderSummary = "_ue-0";
export var rightArrow = "_ue-4";